import React from "react";

export const Registration = (props) => {
  return (
    <div id="registration" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <h2>Registration and Submission</h2>
        </div>
        <br></br>
        <div className="col-md-8 col-md-offset-2 text-justify-xs">
          <div className="registration-text">
            <p>
              Registration for the congress is open. Please register using the
              following link:
            </p>
            <br></br>
            <div class="text-center">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdhZ88BNyM2b0jTvBJKHGgFqPt-KQn7GlU3fJw6UO4GvhmxDw/viewform?usp=dialog"
                target="_blank"
                rel="noreferrer"
                class="btn btn-info"
                role="button"
              >
                Registration
                <br></br>Submission
                <br></br>Form
              </a>
            </div>

            <br></br>
            <p>
              Using the same link the participants can also submit their
              abstracts. If you want to present more than one paper, up to three
              additional abstracts are allowed.
            </p>
            <p>
              {" "}
              After you complete the registration/submission you will receive
              the confirmation email with the registration ID. Please save the
              registration ID for future reference.
            </p>
            <p>Full paper template (MS Word): </p>
            <a href="docx/AAAA_2025-full_paper_template.docx">
              DOWNLOAD TEMPLATE HERE
            </a>
            <br></br>
            <br></br>
            <p>
              The presentations of contributed papers in technical sessions
              shall be given in oral/lecture form. The presentation slots are
              set to 20 minutes. Due to two parallel sessions, the time schedule
              shall be strictly enforced by the session chairs. The presenters
              shall have 15 minutes for presenting their work followed by three
              minutes for questions, while the last two minutes shall be
              reserved for the preparation of the next presenter and for
              changing the session/room for the members of the audience who wish
              to do so.
            </p>
            <p>
              Each of the two session rooms shall be equipped with a visual
              presentation device (a large TV screen) and a pair of loudspeakers
              for stereo audio reproduction.
            </p>
            <p>Please prepare your presentations in .pptx or .pdf format.</p>
            <p>
              Please contact your session chair before the start of your session
              and copy your presentation to the presentation computer at that
              time (or earlier if you have the opportunity to do so).
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
